import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.svg";
import menubar from "../assets/menuIcon.svg";

const sections = ["home", "stories", "impact", "faqs"];

export default function Navbar() {
  const [activeSection, setActiveSection] = useState("home");
  const [menuOpen, setMenuOpen] = useState(false);
  const observerRef = useRef(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: 0.6 }
    );

    sections.forEach((section) => {
      const element = document.getElementById(section);
      if (element) observerRef.current.observe(element);
    });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return (
    <nav className="fixed top-0 left-0 w-full p-3 flex bg-white shadow-md justify-between items-center">
      <Link to="/" className="flex gap-2 items-center">
        <img src={logo} className="w-[36px]" alt="Logo" />
        <p className="font-[400] text-[18px] text-[#049645] hidden md:block">
          Internship Forum Jobs
        </p>
      </Link>

      {/* Desktop Navigation */}
      <section className="hidden md:flex">
        {sections.map((section) => (
          <a
            key={section}
            href={`#${section}`}
            className={`px-4 py-2 transition duration-300 ${
              activeSection === section
                ? "text-green-600 font-bold underline underline-offset-8"
                : "text-gray-300"
            }`}
          >
            {section.charAt(0).toUpperCase() + section.slice(1)}
          </a>
        ))}
      </section>

      {/* Right Side Controls */}
      <div className="flex items-center gap-2">
        <Link to="/login" className="btn btn-light !text-[16px]">
          Login
        </Link>

        {/* Mobile Menu Toggle */}
        <div className="h-fit md:hidden">
          <img
            src={menubar}
            alt="Menu"
            className="cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
          />
        </div>

        <Link
          to="/register"
          className="btn btn-success hidden md:block !text-[16px]"
        >
          Sign Up
        </Link>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="absolute top-full left-0 w-full bg-white shadow-md p-4 flex flex-col items-center space-y-4 md:hidden">
          {sections.map((section) => (
            <a
              key={section}
              href={`#${section}`}
              onClick={() => setMenuOpen(false)}
              className="text-gray-700 text-lg"
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </a>
          ))}
          <Link to="/register" className="btn btn-success w-full text-center">
            Sign Up
          </Link>
        </div>
      )}
    </nav>
  );
}
